import Component from '@glimmer/component';

import can from 'ember-can/helpers/can';

import type ContentItemModel from 'umg-ember-backend/models/content-item';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import ActivityFeed from './activity-feed';
import Article from './article';
import styles from './styles.module.css';

const bem = getBem(styles);

interface DashboardSignature {
  Args: {
    mlp: TODO;
    domain: string;
    activities: Activity[];
  };
}

interface Activity {
  type: string;
  id: string;
  editedAt: string;
}

export default class DashboardComponent extends Component<DashboardSignature> {
  // Getter and setter
  get articles(): ContentItemModel[] {
    const startPage = this.args.mlp.pages.find((page: TODO) => page.start);

    if (!startPage) {
      return [];
    }

    return startPage.contentItems.filter(
      (contentItem: TODO) => contentItem.type === 'article',
    );
  }

  // Template
  <template>
    {{#if (can 'viewNews' 'dashboard')}}
      <div class={{(bem)}}>
        <ActivityFeed @activities={{@activities}} />
        {{#each this.articles key='id' as |article|}}
          <Article @article={{article}} @domain={{@domain}} />
        {{/each}}
      </div>
    {{/if}}
  </template>
}
